import * as Yup from 'yup'

import {
  ScheduledCommunicationTypeBaselineMetricTypes,
  ScheduledCommunicationTypeChannels,
  ScheduledCommunicationTypeScheduleUnits,
} from '@/types/ScheduledCommunicationType'

export const initialValues = {
  active: true,
  baselineMetric: ScheduledCommunicationTypeBaselineMetricTypes.BeforeMoveIn,
  defaultToApproved: true,
  leadTime: 1,
  numberOfScheduleUnits: 0,
  scheduledCommunicationChannel: ScheduledCommunicationTypeChannels.SMS,
  scheduleUnits: ScheduledCommunicationTypeScheduleUnits.Days,
  timeToSend: '',
}

export const formSchema = Yup.object().shape({
  active: Yup.bool().required('Active is required.'),
  defaultToApproved: Yup.bool().required('Default to approved is required.'),
  leadTime: Yup.number().required('Lead time to schedule the communication is required.'),
  timeToSend: Yup.string().required('Time to send is required.'),
})

export interface FormValuesType {
  active: boolean
  baselineMetric: ScheduledCommunicationTypeBaselineMetricTypes
  defaultToApproved: boolean
  leadTime: number
  numberOfScheduleUnits: number
  scheduleUnits: ScheduledCommunicationTypeScheduleUnits
  scheduledCommunicationChannel: ScheduledCommunicationTypeChannels
  timeToSend: string
}
